import { render, staticRenderFns } from "./OrderHomePopup.vue?vue&type=template&id=6e3b77b5&scoped=true"
import script from "./OrderHomePopup.vue?vue&type=script&lang=js"
export * from "./OrderHomePopup.vue?vue&type=script&lang=js"
import style0 from "./OrderHomePopup.vue?vue&type=style&index=0&id=6e3b77b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3b77b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e3b77b5')) {
      api.createRecord('6e3b77b5', component.options)
    } else {
      api.reload('6e3b77b5', component.options)
    }
    module.hot.accept("./OrderHomePopup.vue?vue&type=template&id=6e3b77b5&scoped=true", function () {
      api.rerender('6e3b77b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/popupWindows/components/OrderHomePopup.vue"
export default component.exports